export default {
  loading: false,
  filters: {},
  microStatusLogisticProviders: [],
  microStatusShippers: [],
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-micro-status/store/states.js